<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import VerificationCode from "@/components/modals/verification-code.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import AvailableBursList from '@/components/widgets/available-burs-list.vue';
import BursList from '@/components/widgets/burs-list.vue';
import BursModal from "@/components/modals/burs-modal.vue";
import FinanceAttachments from "@/components/modals/finance-attachments.vue";
import OrderDetailsModal from "@/components/modals/order-details-modal.vue";
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";

export default {
  page: {
    title: "BURS",
  },
  components: {
    Layout,
    PageHeader,
    VerificationCode,
    PrintOptions,
    AvailableBursList,
    BursModal,
    BursList,
    FinanceAttachments,
    OrderDetailsModal
  },
  data() {
    return {
      title: "BURS/OBRS",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "BURS/ORBS",
          active: true,
        },
      ],
      verificationType: "burs-posting",
      isAllowedToPost: false,
      tabModel: 0,
      loading: false,
      bursData: [],
      payments: [],
      purchases: [],
      modalTitle: "",
      selectedBurs: null,
    };
  },
  watch: {
    tabModel: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.changeData(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
      }
    },
  },
  created(){
    if(this.$store.state.decrypt.isAdmin()){
      this.isAllowedToPost = true;
    }else{
      const access = localStorage.getItem("userAccess")
        ? this.$store.state.decrypt.userAccessList()
        : [];
      this.isAllowedToPost = access.find(
          (x) =>
            x.Access.toLowerCase() === "burs-posting" &&
            x.Type.toLowerCase() === "finance"
        )
          ? true
          : false;
    }
    this.changeData(
      this.$store.state.data.cycle,
      this.$store.state.data.selectedCampus.id
    );
  },
  methods: {
    async changeData(cycle, campusId){
      this.loading = true;
      if(this.tabModel == 0){
        await this.fetchAvailable(cycle, campusId);
      }else if(this.tabModel == 1){
        this.bursData = [];
        await this.fetchPending(cycle, campusId);
      }else{
        this.bursData = [];
        await this.fetchPosted(cycle, campusId);
      }
      this.loading = false; 
    },
    async fetchAvailable(cycle, campusId) {
      await this.$store.dispatch("burs/getAvailable", {
        cycle: cycle,
        campusId: campusId,
      })
      .then((res) => {
        if (res.data.error) {
          return this.showToast(res.data.errorMessage, "error");
        }
        res.data.map(item => {
          item.viewDetails = false;
          item.filterKey = `${item.particulars} ${item.rfpNumber} ${item.payee} ${item.deliveryUnit} ${item.serialNumber}`;
        })
        this.formatResponse(res.data);
      })
      .catch((err) => {
        this.showToast('Something went wrong!', "error");
      });
    },
    
    async fetchPending(cycle, campusId) {
      await this.$store.dispatch("burs/getPendingBurs", {
        cycle: cycle,
        campusId: campusId,
      })
      .then((res) => {
        if (res.data.error) {
          return this.showToast(res.data.errorMessage, "error");
        }
        let newData = [];
        res.data.map(item => {
          if(item.isDueAndDemandable && (item.parentBursId == 0 || item.parentBursId == null)){
            newData.push({
              ...item,
              viewDetails: false,
              showPopover: false,
              filterKey: `${item.particulars} ${item.rfpNumber} ${item.payee} ${item.deliveryUnit} ${item.serialNumber}`,
              showChild: false,
            });
          }else{
            newData.push({
              ...item,
              viewDetails: false,
              showPopover: false,
              filterKey: `${item.particulars} ${item.rfpNumber} ${item.payee} ${item.deliveryUnit} ${item.serialNumber}`,
              showChild: false,
            });
          }
        })
        this.bursData = newData;
      })
      .catch((err) => {
        this.showToast('Something went wrong!', "error");
      });
    },
    async fetchPosted(cycle, campusId) {
      await this.$store.dispatch("burs/getPostedBurs", {
        cycle: cycle,
        campusId: campusId,
      })
      .then((res) => {
        if (res.data.error) {
          return this.showToast(res.data.errorMessage, "error");
        }
        let newData = [];
        res.data.map(item => {
          if(item.isDueAndDemandable && (item.parentBursId == 0 || item.parentBursId == null)){
            newData.push({
              ...item,
              viewDetails: false,
              showPopover: false,
              filterKey: `${item.particulars} ${item.rfpNumber} ${item.payee} ${item.deliveryUnit} ${item.serialNumber}`,
              showChild: false,
            });
          }
          if(!item.isDueAndDemandable){
            newData.push({
              ...item,
              viewDetails: false,
              showPopover: false,
              filterKey: `${item.particulars} ${item.rfpNumber} ${item.payee} ${item.deliveryUnit} ${item.serialNumber}`,
              showChild: false,
            });
          }
        })
        this.bursData = newData;
      })
      .catch((err) => {
        this.showToast('Something went wrong!', "error");
      });
    },
    async verifyNow(code) {
      await this.$store
        .dispatch("verification/verifyCode", {
          code: code,
          type: this.verificationType,
        })
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.$bvModal.hide("verify-modal");
        })
        .catch((err) => {
          this.showToast('Something went wrong!', "error");
        });
    },
    formatResponse(data){
      this.bursData = cloneDeep(data);
      this.purchases = data.filter(x => x.type.toLowerCase().includes('po'));
      this.payments = data.filter(x => x.type.toLowerCase().includes('payment'));
    },
    createBurs(data) {
      this.modalTitle = "Create Obligation";
      this.$refs.bursModal.setRfpData(data);
      let part = '';
      if(data.type.toLowerCase() === 'po'){
        part = `${data.particulars}.\n\nPO No. ${data.poNumber}\nPR No. ${data.prNumber}`;
      }else{
        part = `${data.particulars}.\n\nPayment No. ${data.rfpNumber}`;
      }
      this.$refs.bursModal.updateData({
        id: 0,
        rfpId: data.id,
        bursDate: new Date(),
        particulars: part,
        parentBursId: 0,
        isDueAndDemandable: true,
      });
      this.$bvModal.show("burs-modal");
    },
    async showAttachment(data) {
      this.$refs.finAttach.setUploadOpt({
        type: "BURS",
        placement: "left",
        folder: "Finance",
      });
      this.$refs.finAttach.getAttachments(data.att, data.id);
      this.$bvModal.show("finance-attachment-modal");
    },
    async submitBurs(modalData) {
      if(modalData.id > 0){
        await this.$store
          .dispatch("burs/updateBurs", modalData)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            let index = this.bursData.findIndex(x => x.id == modalData.id);
            this.bursData.splice(index, 1, modalData);
            this.purchases = this.bursData.filter(x => x.type == 'PO');
            this.payments = this.bursData.filter(x => x.type == 'Payments');
            this.showToast('Successfully updated', "success");
            this.$bvModal.hide("burs-modal");
          })
          .catch((err) => {
            this.showToast('Something went wrong!', "error");
          });
      }else{
        await this.$store
          .dispatch("burs/createBurs", modalData)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            let index = this.bursData.findIndex(x => x.id == modalData.rfpId);
            this.bursData.splice(index, 1);
            this.purchases = this.bursData.filter(x => x.type == 'PO');
            this.payments = this.bursData.filter(x => x.type == 'Payments');
            this.showToast('Successfully created', "success");
            this.$bvModal.hide("burs-modal");
          })
          .catch((err) => {
            this.showToast('Something went wrong!', "error");
          });
      }
    },
    postBurs({form, data}){
      // Swal.fire({
      //   title: "Are you sure?",
      //   text: "You won't be able to revert this!",
      //   icon: "warning",
      //   showCancelButton: true,
      //   confirmButtonColor: "#28c76f",
      //   cancelButtonColor: "#5c636a",
      //   confirmButtonText: "Yes, post it!",
      // }).then((result) => {
      //     if (result.value) {
            this.$store
              .dispatch("burs/postBurs", {
                id: data.id,
                dateTime: this.getDate(form.postDate),
              })
              .then((res) => {
                if(res.data.error){
                  return this.showToast(res.data.errorMessage, "error");
                }
                let index = this.bursData.findIndex(x => x.id == data.id);
                this.bursData.splice(index, 1);
                this.showToast('Successfully posted', "success");
              }).catch((err) => {
                this.showToast('Something went wrong!', "error");
              });
          // }
      // });
    },
    async printBurs(id) {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/BURS",
        routeVariables: [id],
      });
      this.$bvModal.show("print-options-modal");
    },
    rejectRequest(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, reject it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("burs/rejectBurs", item.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let index = this.bursData.findIndex(x => x.id == item.id);
              this.bursData.splice(index, 1);
              this.showToast('Successfully rejected', "success");
            })
            .catch((err) => {
              this.showToast('Something went wrong!', "error");
            });
        }
      });
    },
    updateRequest(item){
      this.modalTitle = "Request for Obligation";
      this.$refs.ordModalRef.updateData({
        id: item.id,
        particulars: item.particulars,
        rfpDate: new Date(item.rfpDate)
      });
      this.$bvModal.show("order-details-modal");
    },
    removeBurs(item){
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("burs/deleteBurs", item)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let index = this.bursData.findIndex(x => x.id == item);
              this.bursData.splice(index, 1);
              this.showToast('Successfully removed', "success");
            })
            .catch((err) => {
              this.showToast('Something went wrong!', "error");
            });
        }
      });
    },
    updateBurs(item){
      this.selectedBurs = item;
      this.$refs.bursModal.getRFPData(item.rfpId, item.type);
      this.$refs.bursModal.updateData(item);
      this.modalTitle = "Update Obligation";
      this.$bvModal.show("burs-modal");
    },
    async submitOrderDetails(modalData){
      await this.$store
        .dispatch("rfppo/UpdateRfpPo", modalData)
        .then((res) => {
            if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
            }
            let purIndex = this.purchases.findIndex((i) => i.id == modalData.id);
            if(purIndex > -1){
              this.purchases[purIndex].rfpDate = JSON.parse(JSON.stringify(modalData.rfpDate));
              this.purchases[purIndex].particulars = JSON.parse(JSON.stringify(modalData.particulars));
            }
            let payIndex = this.payments.findIndex((i) => i.id == modalData.id);
            if(payIndex > -1){
              this.payments[purIndex].rfpDate = JSON.parse(JSON.stringify(modalData.rfpDate));
              this.payments[purIndex].particulars = JSON.parse(JSON.stringify(modalData.particulars));
            }
            this.$bvModal.hide("order-details-modal");
            this.showToast('Successfully updated', 'success')
        })
        .catch((err) => {
            let stringErr = err.toString();
            if (stringErr.includes("Network")) this.showToast("Network Error!", "error");
            else this.showToast("Something went wrong requesting!", "error");
        });
    },
    addMoreObligation(item){
      this.selectedBurs = item;
      this.$refs.bursModal.getRFPData(item.rfpId);
      this.$refs.bursModal.updateData({
        id: 0,
        bursDate: new Date(item.bursDate),
        particulars: item.particulars,
        isDueAndDemandable: true,
        rfpId: item.rfpId,
        parentBursId: item.id,
      });
      this.modalTitle = "Add More Obligation";
      this.$bvModal.show("burs-modal");
    },
  }
};

</script>
<template>
  <Layout @changeCycle="changeData($event, $store.state.data.selectedCampus.id)" @changeCampus="changeData($store.state.data.cycle, $event.id)">
    <PageHeader :title="title" :items="items" />
    <VerificationCode
      @dropCode="verifyNow"
      ref="verification"
    />
    <b-tabs
      v-model="tabModel"
      pills
      vertical
      nav-class="p-0"
      nav-wrapper-class="col-sm-2 border-end"
      content-class="pt-0 px-2 text-muted"
  >
      <b-tab title-item-class="mb-2">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-user"></i>
          </span>
          <span class="d-none d-sm-inline-block"><i class="bx bx-book-content me-1"></i>Available</span>
        </template>
        <AvailableBursList 
          :loading="loading"
          :purchases="purchases"
          :payments="payments"
          @create="createBurs"
          @attachment="showAttachment"
          @reject="rejectRequest"
          @update="updateRequest"
        />
      </b-tab>
      <b-tab title-item-class="mb-2">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-user"></i>
          </span>
          <span class="d-none d-sm-inline-block"><i class="bx bx-layer me-1"></i>Pending</span>
        </template>
        <BursList 
          type="pending"
          :loading="loading"
          :list="bursData"
          @attachment="showAttachment"
          v-if="tabModel == 1"
          @post="postBurs"
          @printBurs="printBurs($event)"
          @remove="removeBurs($event)"
          @update="updateBurs($event)"
        />
      </b-tab>
      <b-tab title-item-class="mb-2">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="bx bx-user"></i>
          </span>
          <span class="d-none d-sm-inline-block"><i class="bx bx-spreadsheet me-1"></i>Posted</span>
        </template>
        <BursList 
          type="posted"
          :loading="loading"
          :list="bursData"
          @attachment="showAttachment"
          @addMore="addMoreObligation"
          v-if="tabModel == 2"
          @printBurs="printBurs($event)"
        />
      </b-tab>
    </b-tabs>
    <print-options ref="printOpt"></print-options>
    <BursModal :modalTitle="modalTitle" ref="bursModal" @submit="submitBurs" />
    <FinanceAttachments 
      ref="finAttach"
      :wActions="true"
    />
    <OrderDetailsModal ref="ordModalRef" @submit="submitOrderDetails" />
  </Layout>
</template>
<style lang="scss">
.border-end {
  border-right: 1px solid var(--bs-border-color);
}
</style>